import { css } from "styled-components";

import { deepPurpleMui } from "../declarations";
import { rydeColors } from "../parts";

export const tooltipsStyles = css`
  .navigation-menu-tooltip {
    &.MuiTooltip-tooltip {
      background-color: ${deepPurpleMui.A400};
      border: 1px solid ${deepPurpleMui.A400};
      color: ${rydeColors.white};

      .MuiTooltip-arrow {
        color: ${deepPurpleMui.A400};
      }
    }
  }
`;
